import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { KeyValues3, LocalService, Paging, Wrappers5, GalleryType, KeyValues5, StatusWithId, ActiveInactiveFor, KeyValues10, KeyValues5Sets, Wrappers10 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class GalleryManagementService {
  private controllerName = service_controllers_methods.gallery.controller;
  private methods = service_controllers_methods.gallery.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public getGalleriesTech(galleryType: GalleryType, businessId: string, parentId: string, paging: Paging): Observable<Wrappers5> {
    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      dt: {
        key: galleryType.toString(),
        v1: businessId,
        v2: parentId
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetGalleriesTech, body);
  }

  public getGalleriesByType(galleryType: GalleryType, businessId: string, parentId: string): Observable<KeyValues10[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        key: galleryType.toString(),
        v1: businessId,
        v2: parentId
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetGalleriesByType, body);
  }

  public saveGallery(id: string, title: string, order?: number | string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        key: id,
        v1: title,
        v2: order ? order.toString() : ''
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveGallery, body);
  }

  public saveGalleryTitle(id: string, title: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        key: id,
        v1: title
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveGalleryTitle, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public removeGallery(id: string, parentId: string, businessId: string, galleryType: GalleryType): Observable<StatusWithId[]> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        key: id,
        v1: parentId,
        v2: businessId,
        v3: galleryType.toString()
      } as KeyValues5
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.RemoveGallery, body);
  }

  public getReceiptFiles(businessId: string, receiptId: string): Observable<Wrappers10> {
    let body = {
      sel: this.localService.getSelected(),
      dt: {
        v1: businessId,
        v2: receiptId
      } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetReceiptFiles, body);
  }
}
